import React from 'react'
import styled from 'styled-components'
import AddNew from 'components/form/add-new'
import CashflowItem from 'components/form/cashflow/cashflow-item'
import NumDisplay from 'components/num-display'
import { determineColor, moneyFormat } from 'utils/helpers'

const LayoutGrid = styled.div`
  display: grid;
  grid-template-columns: 10fr minmax(0, 2fr);
  grid-gap: 60px;
  @media (max-width: 767px) {
    display: block;
  }
  & h2 {
    font-size: 42px;
  }
  & h3 {
    font-size: 32px;
  }
`

const ItemGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.cols ? props.cols : 2}, 1fr);
  grid-gap: 30px;
  @media (max-width: 767px) {
    display: block;
  }
`

export default ({ sectionId, id, data }) => {  
  const calcCashflowField = fieldName => {
    return Object.values(data).reduce((prev, curr) => (
      curr.frequency && curr.frequency === 'Annually'
        ? prev + (curr[fieldName] / 12)
        : prev + curr[fieldName]
    ), 0)
  }

  const totalCurrent = calcCashflowField('current')
  const totalProjected = calcCashflowField('projected')
  const sectionTotal = (totalProjected - totalCurrent)
  const sectionTotalColor = determineColor(sectionTotal)
  
  return (
    <LayoutGrid>
      <fieldset>
        <legend><h2>{id}</h2></legend>
        <ItemGrid>
          { Object.entries(data).map(d => {
            const [ k, v ] = d
            return (
              <div key={k}>
                <CashflowItem sectionId={sectionId} id={k} fields={v} />
              </div>
            )
          }) }
          <AddNew sectionId={id} />
        </ItemGrid>
      </fieldset>
      <div>
        <h3>Section Totals</h3>
        <NumDisplay bigNum={`${moneyFormat.to(totalProjected)}/mo`} heading="projected" />
        <NumDisplay bigNum={`${moneyFormat.to(totalCurrent)}/mo`} heading="current" />
        <hr/>
        <NumDisplay bigNum={`${moneyFormat.to(sectionTotal)}/mo`} heading="Difference" style={{color: sectionTotalColor}} />
      </div>
    </LayoutGrid>
  )
}